"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    APP_ROOT: "profile",
    PAYPAL_URI: "/",
    LEGACY_SETTINGS_URI: "/myaccount/settings",
    REQUEST_URI: "/myaccount/profile",
    BASE_URI: "/myaccount/profile",
    SETTINGS_UNSUBSCRIBE: "/myaccount/settings/notifications/marketing",
    ROUTES: {
        ACCOUNT: "/",
        UNSUBSCRIBE: "/unsubscribe",
        COOKIES: "/cookies",
        COOKIE_PREFS: "/cookies",
        NOTIFICATIONS: "/notifications",
        SECURITY: "/security",
        PAYMENTS: "/payments",
        SELLER_TOOLS: "/seller-tools",
        EMAILS: {
            ADD: "/emails/add",
            EDIT: "/emails/edit",
        },
        PASSPORT: {
            UPDATE: "/passport/update",
            DELETE: "/passport/delete",
            DELETE_SUCCESS: "/passport/delete/success",
            UPDATE_SUCCESS: "/passport/update/success",
        },
        NAME: {
            GET: "/name/get",
            UPDATE: "/name/edit",
            CHANGE_REASON: "/name/changeReason",
            UPDATE_SUCCESS: "/name/success",
            MINOR_NAME_CHANGE: "/name/minorchange",
            MAJOR_NAME_CHANGE: "/name/majorchange",
            LEGAL_NAME_CHANGE: "/name/legalchange",
            MAIL_FILES_NAME_CHANGE: "/name/mailchange",
        },
        COOKIE: {
            GET: "/cookies",
        },
        PHONES: {
            MANAGE: "/phones",
            ADD: "/phones/add",
            EDIT: "/phones/:id/edit",
            UPDATE_PPC: "/phones/ppc/update",
            REMOVE: "/phones/:id/delete",
            MAKE_PRIMARY: "/phones/:id/makePrimary",
            CHANGE_PRIMARY: "/phones/:id/changePrimary",
            VALIDATE_CONFIRMATION: "/phones/:id/validateConfirm",
        },
        OCCUPATION: {
            GET: "/occupation/:action",
        },
        ADDRESSES: {
            MANAGE: "/addresses",
            ADD: "/addresses/add",
            EDIT_PPC: "/addresses/ppc/update",
            EDIT: "/addresses/:id/edit",
            REMOVE: "/addresses/:id/delete",
            MAKE_PRIMARY: "/addresses/:id/makePrimary",
            STATE: {
                LIST: "/addresses/states",
            },
            BILLING: {
                ADD: "/addresses/:id/delete/new",
            },
            FLOW_BASE: "/flow/addresses",
        },
        EXTEND_SESSION: "/extend-session",
        FLOW_ERROR: "/myaccount/profile/flow/error?type=dataRetrieval",
        API: {
            EMAILS: {
                EDIT: "/api/emails/edit",
            },
            PASSPORT: {
                UPDATE: "/api/passport/update",
                DELETE: "/api/passport/delete",
            },
            NAME: {
                MINOR_UPDATE: "/api/name/minor/edit",
                MAJOR_LEGAL_UPDATE: "/api/name/major/edit",
                GET: "/api/name/get",
                CHECK_NAME_CHANGE_RISK_LEVEL: "/api/name/getRiskLevel",
                UPDATE: "/api/name/update",
            },
            NOTIFICATIONS: {
                UPDATE: "/api/notifications/update",
            },
            UNSUBSCRIBE: {
                UPDATE: "/api/unsubscribe/update",
            },
            COOKIES: {
                UPDATE: "/api/cookies/update",
                ACCEPT: "/api/cookies/accept",
            },
            COOKIE_PREFS: {
                UPDATE: "/api/cookiePrefs/update",
            },
            PHONES: {
                ADD: "/api/phone/add",
                EDIT: "/api/phone/edit",
                SET_TCPA: "/api/phone/setTcpa",
                GET_TCPA: "/api/phone/getTcpa",
                REMOVE: "/api/phone/delete",
                MAKE_PRIMARY: "/api/phone/makePrimary",
                CONFIRM: "/api/phone/confirm",
                VALIDATE_CONFIRM: "/api/phone/validateConfirm",
            },
            ADDRESSES: {
                ADD: "/api/addresses/add",
                EDIT: "/api/addresses/edit",
                REMOVE: "/api/addresses/delete",
                MAKE_PRIMARY: "/api/address/makePrimary",
                BILLING: {
                    REMOVE: "/api/address/billing/delete",
                    EDIT: "/api/address/billing/edit",
                },
                STATE: {
                    LIST: "api/address/state/list",
                },
            },
            OCCUPATION: {
                UPDATE: "/api/occupation/edit",
            },
        },
    },
    PAGES: {
        ACCOUNT: "account",
        NOTIFICATIONS: "notifications",
        SECURITY: "security",
        PAYMENTS: "payments",
        UNSUBSCRIBE: "unsubscribe",
        COOKIES: "cookies",
        UPDATE_PASSPORT: "update-passport",
        DELETE_PASSPORT: "delete-passport",
        UPDATE_PASSPORT_SUCCESS: "update-passport-success",
        DELETE_PASSPORT_SUCCESS: "delete-passport-success",
        SELLER_TOOLS: "seller-tools",
    },
    VIEWS: {
        EMAILS: {
            ADD: "addEmail",
            EDIT: "editEmail",
        },
        GLOBAL_ERROR: "globalError",
        EXTEND_SESSION: "extendSession",
        NOTIFICATIONS: "notifications",
        UPDATE_PASSPORT: "update-passport",
        UPDATE_PASSPORT_SUCCESS: "update-passport-success",
        DELETE_PASSPORT: "delete-passport",
        DELETE_PASSPORT_SUCCESS: "delete-passport-success",
        UPDATE_NAME: "update-name",
        NEW_UPDATE_NAME: "new-update-name",
        CHANGE_REASON: "change-reason",
        UPDATE_NAME_SUCCESS: "update-name-success",
        MINOR_NAME_CHANGE: "update-name-minor",
        MAJOR_NAME_CHANGE: "update-name-major",
        LEGAL_NAME_CHANGE: "update-name-legal",
        MAIL_FILES_NAME_CHANGE: "update-name-mail-files",
        UPDATE_PPC: "update-ppc",
        COOKIES: "cookies",
        COOKIE_PREFS: "cookiePrefs",
        SELLER_TOOLS: "seller-tools",
        UPDATE_OCCUPATION: "update-occupation",
        ADDRESSES: {
            ADD: "add-address",
            UPDATE: "update-address",
            DELETE: "delete-address",
            EDIT_PPC: "edit-ppc",
            MAKE_PRIMARY: "set-primary",
            MANAGE: "manage",
            STATE: {
                LIST: "state-list",
            },
            BILLING: {
                ADD: "add-billing-address",
                UPDATE: "update-billing-address",
                DELETE: "delete-billing-address",
            },
            TOAST_INTENTS: {
                SET_PRIMARY: "set_primary",
                ADD: "add",
                EDIT: "edit",
                REMOVE: "remove",
                REMOVE_PRIMARY: "remove_primary",
                ADD_AS_PRIMARY: "add_as_primary",
                UPADTE_PRIMARY: "update_primary",
                REMOVE_BILLING_PRIMARY: "remove_billing_primary",
                REMOVE_BILLING_PRIMARY_ADD_NEW: "remove_billing_primary_add_new",
                REMOVE_BILLING: "remove_billing",
                REMOVE_BILLING_ADD_NEW: "remove_billing_add_new",
                REMOVE_BILLING_ADD_NEW_PRIMARY: "remove_billing_add_new_primary",
                UPDATE_BILLING_PRIMARY: "update_billing_primary",
                UPDATE_BILLING: "update_billing",
                UPDATE_BILLING_AS_PRIMARY: "update_billing_as_primary",
            },
        },
        PHONES: {
            ADD: "add-phone",
            UPDATE: "add-phone",
            DELETE: "delete-phone",
            MAKE_PRIMARY: "make-primary",
            CHANGE_PRIMARY: "change-primary-phone",
            CHANGE_PRIMARY_ADD: "change-primary-add-phone",
            MANAGE: "manage-phones",
            VALIDATE_CODE: "validate-code-phone",
            TOAST_INTENTS: {
                SET_PRIMARY: "set_primary",
                ADD: "add",
                EDIT: "edit",
                REMOVE: "remove",
                REMOVE_PRIMARY: "remove_primary",
                ADD_AS_PRIMARY: "add_as_primary",
                UPDATE_PRIMARY: "update_primary",
                CONFIRM: "confirm",
            },
            LABELS: {
                WORK: "work",
                HOME: "home",
                MOBILE: "mobile",
            },
        },
    },
    FLOWS: {
        NOTIFICATIONS_PAGE: "notifications",
        PASSPORT_PAGE: "passportPage",
        MANAGE: "managePage",
        ADDRESS: "address",
        PHONE: "phonePage",
        NAME_PAGE: "name",
        CHANGE_REASON: "changeReason",
        MINOR_NAME_PAGE: "minorName",
        MAJOR_NAME_PAGE: "majorName",
        LEGAL_NAME_PAGE: "legalName",
        COOKIES_PAGE: "cookies",
        OCCUPATION: "occupation",
        UNDEFINED: "undefined",
    },
    FPTI: {
        SUCCESS: "success",
        FAILURE: "fail",
    },
    BADGES: {
        PRIMARY: "primary",
        PRIMARY_WORK: "primary_work",
        PRIMARY_HOME: "primary_home",
        PRIMARY_MOBILE: "primary_mobile",
        NEW: "new",
        UPDATED: "updated",
        UNCONFIRMED: "unconfirmed",
    },
    PHONE_TYPE: {
        MOBILE: "MOBILE",
        WORK: "WORK",
        HOME: "HOME",
    },
    TCPA: {
        CATEGORY: "4.4.49",
        TYPE: {
            VOICE: "VOICE",
            SMS: "SMS",
        },
        STATUS: {
            ON: "On",
            OFF: "Off",
        },
    },
    OPERATION: {
        ADD: "add",
        UPDATE: "update",
        GET: "get",
    },
};
